(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      if (!this.header) return;
      this.headerIsFixed = this.getAttribute('data-fixed-header') === 'true';
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsFixed) {
        this.initialHeaderTop = this.header.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop);
        this.onFixedScrollHandler = this.onFixedScroll.bind(this);
        window.addEventListener('scroll', this.onFixedScrollHandler, { passive: true });
        this.onFixedScroll();
        return;
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this._headerHeightRaf = null;
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      var rect = this.header.getBoundingClientRect();
      document.documentElement.style.setProperty('--header-total-height', `${rect.bottom}px`);
    }

    onFixedScroll() {
      if (!this.header) return;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (!this.header.classList.contains('header-is-fixed')) {
        this.setHeaderHeight();
        this.initialHeaderTop = this.header.getBoundingClientRect().top + scrollTop;
      }
      if (scrollTop > this.initialHeaderTop) {
        this.setHeaderHeight();
        document.body.classList.add('header-fixed-active');
        this.header.classList.add('header-is-fixed');
        var bg = getComputedStyle(this.header).backgroundColor;
        if (bg) document.body.style.setProperty('--header-fixed-bg', bg);
      } else {
        document.body.classList.remove('header-fixed-active');
        this.header.classList.remove('header-is-fixed');
        document.body.style.removeProperty('--header-fixed-bg');
      }
    }

    disconnectedCallback() {
      if (this.headerIsFixed) {
        window.removeEventListener('scroll', this.onFixedScrollHandler);
        document.body.classList.remove('header-fixed-active');
        document.body.style.removeProperty('--header-fixed-bg');
        if (this.header) this.header.classList.remove('header-is-fixed');
        return;
      }
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this.header) return;
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (!this.header) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this._headerHeightRaf == null) {
        this._headerHeightRaf = requestAnimationFrame(() => {
          this.setHeaderHeight();
          this._headerHeightRaf = null;
        });
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (!this.header || this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (!this.header || this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (!this.header || this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  // Brand Logo Loading für "Marken" Menü
  (function() {
    const logoCache = {};
    
    function loadBrandLogos() {
      // Finde alle Brand-Links im "Marken" Menü
      const brandLinks = document.querySelectorAll('.mega-menu__link--brand');
      
      brandLinks.forEach(function(link) {
        // Überspringe wenn bereits Logo geladen wurde
        if (link.dataset.logoLoaded === 'true') return;
        if (link.dataset.logoLoaded === 'loading') return;
        
        const brandName = link.dataset.brandName;
        
        if (!brandName) return;
        
        // Prüfe Cache
        if (logoCache[brandName]) {
          applyLogo(link, logoCache[brandName], brandName);
          return;
        }
        
        // Markiere als "wird geladen"
        link.dataset.logoLoaded = 'loading';
        
        // Finde die erste Unterkategorie (z.B. "Hardtail" bei Cube)
        // Suche nach dem nächsten <ul> Element mit Unterkategorien
        const parentLi = link.closest('li');
        if (!parentLi) {
          console.warn('Could not find parent li for brand:', brandName);
          link.dataset.logoLoaded = 'failed';
          return;
        }
        
        // Suche nach der ersten Unterkategorie-Link
        const subCategoryLink = parentLi.querySelector('ul.list-unstyled a.mega-menu__link');
        let collectionUrl = null;
        
        if (subCategoryLink && subCategoryLink.href) {
          // Verwende die erste Unterkategorie (z.B. /collections/cube-hardtail)
          collectionUrl = subCategoryLink.href;
        } else {
          // Fallback: Verwende die Haupt-Collection
          collectionUrl = link.dataset.collectionUrl || link.href;
        }
        
        if (!collectionUrl) {
          console.warn('Could not find collection URL for brand:', brandName);
          link.dataset.logoLoaded = 'failed';
          return;
        }
        
        // Extrahiere Collection Handle aus URL
        const collectionHandle = collectionUrl.match(/\/collections\/([^\/\?]+)/)?.[1];
        
        if (!collectionHandle) {
          console.warn('Could not extract collection handle from URL:', collectionUrl);
          link.dataset.logoLoaded = 'failed';
          return;
        }
        
        // Lade Collection HTML-Seite direkt (enthält Metafields in gerenderten Produktkarten)
        fetch(collectionUrl)
          .then(response => {
            if (!response.ok) {
              throw new Error(`Collection HTML nicht verfügbar: ${response.status}`);
            }
            return response.text();
          })
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            // Suche nach der ersten Produktkarte mit Brand-Logo
            // Die Produktkarten haben das Logo als <img> mit src-Attribut
            const brandLogoImg = doc.querySelector('img[src*="media.bidex.bike"], img[src*="linID-"]');
            
            if (brandLogoImg && brandLogoImg.src) {
              const logoUrl = brandLogoImg.src;
              console.log(`Brand-Logo gefunden im HTML für ${brandName}: ${logoUrl}`);
              return Promise.resolve({ logoUrl: logoUrl });
            }
            
            // Fallback: Suche nach Produkt-Link und lade Produkt-JSON
            const productLink = doc.querySelector('a[href*="/products/"]');
            if (!productLink) {
              throw new Error('Kein Produkt-Link in HTML gefunden');
            }
            
            const productUrl = productLink.getAttribute('href');
            const productHandle = productUrl.match(/\/products\/([^\/\?]+)/)?.[1];
            
            if (!productHandle) {
              throw new Error('Produkt-Handle nicht aus URL extrahiert');
            }
            
            console.log(`Lade Produkt ${productHandle} für Brand ${brandName} aus Collection ${collectionHandle}`);
            
            // Hole Produktdaten via Shopify JSON API
            return fetch(`/products/${productHandle}.js`)
              .then(response => {
                if (!response || !response.ok) {
                  throw new Error(`Produkt JSON nicht verfügbar: ${response?.status}`);
                }
                return response.json();
              })
              .then(product => {
                // Versuche Metafields aus Produkt zu extrahieren
                return { product: product };
              });
          })
          .catch(error => {
            console.warn('Collection HTML fehlgeschlagen für', brandName, ':', error);
            // Fallback: Versuche die Haupt-Collection
            const mainCollectionUrl = link.dataset.collectionUrl || link.href;
            if (mainCollectionUrl && mainCollectionUrl !== collectionUrl) {
              return fetch(mainCollectionUrl)
                .then(response => {
                  if (!response.ok) {
                    throw new Error(`Haupt-Collection HTML nicht verfügbar: ${response.status}`);
                  }
                  return response.text();
                })
                .then(html => {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(html, 'text/html');
                  
                  const brandLogoImg = doc.querySelector('img[src*="media.bidex.bike"], img[src*="linID-"]');
                  if (brandLogoImg && brandLogoImg.src) {
                    return Promise.resolve({ logoUrl: brandLogoImg.src });
                  }
                  throw new Error('Kein Logo in Haupt-Collection gefunden');
                });
            }
            throw error;
          })
          .then(result => {
            // Prüfe ob Logo direkt aus HTML extrahiert wurde
            if (result.logoUrl) {
              console.log(`✅ Brand-Logo gefunden für ${brandName}: ${result.logoUrl}`);
              logoCache[brandName] = result.logoUrl;
              applyLogo(link, result.logoUrl, brandName);
              return;
            }
            
            // Ansonsten verarbeite Produkt-Daten
            const product = result.product;
            if (!product) {
              console.warn(`Kein Produkt-Daten für ${brandName}`);
              link.dataset.logoLoaded = 'failed';
              return;
            }
            
            // Suche brand_logo_url Metafield - genau wie in card-product.liquid
            let brandLogoUrl = null;
            
            console.log(`Verarbeite Produkt ${product.handle} für Brand ${brandName}`);
            console.log('Produkt Metafields:', JSON.stringify(product.metafields, null, 2));
            
            // Shopify JSON API gibt Metafields als Array zurück
            // Format: [{ namespace: 'bidex', key: 'brand_logo_url', value: '...' }, ...]
            if (product.metafields && Array.isArray(product.metafields)) {
              // Suche nach bidex.brand_logo_url
              const brandLogoMetafield = product.metafields.find(
                m => m.namespace === 'bidex' && m.key === 'brand_logo_url'
              );
              
              if (brandLogoMetafield && brandLogoMetafield.value) {
                brandLogoUrl = brandLogoMetafield.value;
                console.log(`Brand-Logo gefunden (brand_logo_url): ${brandLogoUrl}`);
              } else {
                // Fallback: Suche nach brand_id und generiere URL
                const brandIdMetafield = product.metafields.find(
                  m => m.namespace === 'bidex' && m.key === 'brand_id'
                );
                
                if (brandIdMetafield && brandIdMetafield.value) {
                  const brandId = brandIdMetafield.value;
                  brandLogoUrl = `https://media.bidex.bike/linID-${brandId}-250-185-0-0.jpg`;
                  console.log(`Brand-Logo generiert aus brand_id ${brandId}: ${brandLogoUrl}`);
                }
              }
            }
            
            // Fallback: Prüfe ob Metafields als Objekt strukturiert sind (älteres Format)
            if (!brandLogoUrl && product.metafields && typeof product.metafields === 'object' && !Array.isArray(product.metafields)) {
              const bidexMetafields = product.metafields.bidex || {};
              brandLogoUrl = bidexMetafields.brand_logo_url?.value || bidexMetafields.brand_logo_url;
              
              if (!brandLogoUrl) {
                const brandId = bidexMetafields.brand_id?.value || bidexMetafields.brand_id;
                if (brandId) {
                  brandLogoUrl = `https://media.bidex.bike/linID-${brandId}-250-185-0-0.jpg`;
                  console.log(`Brand-Logo generiert aus brand_id (Objekt-Format) ${brandId}: ${brandLogoUrl}`);
                }
              } else {
                console.log(`Brand-Logo gefunden (Objekt-Format): ${brandLogoUrl}`);
              }
            }
            
            // Debug: Zeige Metafields-Struktur
            if (!brandLogoUrl) {
              console.warn(`⚠️ Kein Brand-Logo gefunden für ${brandName} in Produkt:`, product.handle);
              console.log('Produkt Metafields:', product.metafields);
              console.log('Produkt Vendor:', product.vendor);
            }
            
            if (brandLogoUrl) {
              // Cache das Logo
              logoCache[brandName] = brandLogoUrl;
              applyLogo(link, brandLogoUrl, brandName);
            } else {
              link.dataset.logoLoaded = 'failed';
            }
          })
          .catch(error => {
            console.warn('Could not load brand logo for', brandName, 'from', collectionUrl, ':', error);
            link.dataset.logoLoaded = 'failed';
          });
      });
    }
    
    function applyLogo(link, logoUrl, brandName) {
      // Prüfe ob Logo bereits existiert
      if (link.querySelector('img.mega-menu__brand-logo')) {
        console.log(`Logo bereits vorhanden für ${brandName}`);
        return;
      }
      
      console.log(`Wende Logo an für ${brandName}: ${logoUrl}`);
      
      // Erstelle Logo-Image
      const logoImg = document.createElement('img');
      logoImg.src = logoUrl;
      logoImg.alt = brandName;
      logoImg.className = 'mega-menu__brand-logo';
      logoImg.style.cssText = 'max-height: 50px; width: auto; object-fit: contain; display: block; margin-bottom: 0.5rem;';
      logoImg.loading = 'lazy';
      
      // Fehlerbehandlung für Logo
      logoImg.onerror = function() {
        console.warn(`Logo konnte nicht geladen werden: ${logoUrl}`);
        this.style.display = 'none';
      };
      
      logoImg.onload = function() {
        console.log(`Logo erfolgreich geladen für ${brandName}`);
      };
      
      // Ersetze Text durch Logo (Text bleibt für Screen-Reader)
      const linkText = link.querySelector('.mega-menu__link-text');
      if (linkText) {
        linkText.style.cssText = 'position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border-width: 0;';
      }
      
      // Füge Logo vor dem Text ein (oder ersetze den Text)
      if (linkText && linkText.parentNode) {
        linkText.parentNode.insertBefore(logoImg, linkText);
      } else {
        link.insertBefore(logoImg, link.firstChild);
      }
      
      link.dataset.logoLoaded = 'true';
      
      // Stelle sicher, dass der Link weiterhin klickbar ist
      link.style.cursor = 'pointer';
    }
    
    // Warte bis DOM geladen ist
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadBrandLogos);
    } else {
      loadBrandLogos();
    }
    
    // Auch nach Mutationen prüfen (falls Menü dynamisch geladen wird)
    const observer = new MutationObserver(function() {
      loadBrandLogos();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    
    // Lade Logos auch wenn Mega-Menu geöffnet wird
    document.addEventListener('click', function(e) {
      if (e.target && e.target.nodeType === Node.ELEMENT_NODE && e.target.closest && e.target.closest('.mega-menu[open]')) {
        setTimeout(loadBrandLogos, 100);
      }
    });
    
    // Lade Logos auch wenn Mega-Menu per Hover geöffnet wird
    document.addEventListener('mouseenter', function(e) {
      if (e.target && e.target.nodeType === Node.ELEMENT_NODE && e.target.closest && e.target.closest('.mega-menu[open]')) {
        setTimeout(loadBrandLogos, 100);
      }
    }, true);
  })();

  } catch(e) { console.error(e); }
})();
})();
